module.exports = __webpack_public_path__ + "static/media/paysafe-logo.7f3fa711.png";